import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-av-card',
  templateUrl: './av-card.component.html',
  styleUrls: ['./av-card.component.scss']
})
export class AvCardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
